import { render } from "./PackageFormSidebar.vue?vue&type=template&id=69d680a3"
import script from "./PackageFormSidebar.vue?vue&type=script&lang=js"
export * from "./PackageFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__